<template>
  <main class="main mobile_apply_form_detail" role="main" v-if="isCompleted">
    <div class="main_con">
      <div class="mobile_estimate_info">
        <div class="m_e_title">가입(약속) 내역</div>
        <div class="m_e_con">
          <div class="con_txt btmb">
            <dl class="mb04">
              <dt class="txt_1">매장명</dt>
              <dd class="txt_2">
                {{ shop.name }}
              </dd>
            </dl>
            <dl class="mb04">
              <dt class="txt_1">전화 번호</dt>
              <dd class="txt_2">{{ shop.telNumber }}</dd>
            </dl>
            <dl>
              <dt class="txt_1">주소</dt>
              <dd class="txt_2">{{ getAddress(shop.address) }}</dd>
            </dl>
          </div>
          <div class="con_txt btmb">
            <dl class="mb04">
              <dt class="txt_1">신청일</dt>
              <dd class="txt_2">
                {{ getCreateAt(mobileApplyDetail.createdAt) }}
              </dd>
            </dl>
            <dl class="mb04">
              <dt class="txt_1">개통구분</dt>
              <dd class="txt_2" v-if="mobileEstimateDetail.joinType == 'NEW'">
                신규
              </dd>
              <dd
                class="txt_2"
                v-else-if="mobileEstimateDetail.joinType == 'CHANGE'"
              >
                기기변경
              </dd>
              <dd
                class="txt_2"
                v-else-if="mobileEstimateDetail.joinType == 'MNP'"
              >
                번호이동
              </dd>
            </dl>
            <dl class="mb04">
              <dt class="txt_1">할인유형</dt>
              <dd
                class="txt_2"
                v-if="mobileEstimateDetail.payType == 'SUPPORT'"
              >
                공시지원
              </dd>
              <dd
                class="txt_2"
                v-else-if="mobileEstimateDetail.payType == 'PLAN'"
              >
                선택약정
              </dd>
            </dl>
            <dl>
              <dt class="txt_1">통신사</dt>
              <dd class="txt_2">
                {{ mobileEstimateDetail.joinPlanInfo.telecomName }}
              </dd>
            </dl>
          </div>
          <div class="con_txt btmb">
            <dl class="mb04 sb">
              <dt class="txt_1">휴대폰모델</dt>
              <dd class="txt_2">
                {{ mobileRequestView.modelName }}<br />({{
                  mobileRequestView.deviceName
                }})
              </dd>
            </dl>
            <dl class="mb04 sb">
              <dt class="txt_1">출고가</dt>
              <dd class="txt_2">
                {{ toCurrency(mobileEstimateDetail.factoryPrice) }}원
              </dd>
            </dl>
            <dl
              class="mb04 sb"
              v-if="mobileEstimateDetail.payType == 'SUPPORT'"
            >
              <dt class="txt_1">공시지원금</dt>
              <dd class="txt_2">
                {{ toCurrency(mobileEstimateDetail.supportMoney) }}원
              </dd>
            </dl>
            <dl
              class="mb04 sb"
              v-if="
                mobileEstimateDetail.payType == 'SUPPORT' &&
                  mobileEstimateDetail.joinType == 'MNP'
              "
            >
              <dt class="txt_1">전환지원금</dt>
              <dd class="txt_2">
                {{ toCurrency(mobileEstimateDetail.supportMoneyMnp) }}원
              </dd>
            </dl>
            <dl class="mb04 sb">
              <dt class="txt_1">매장지원금</dt>
              <dd class="txt_2 brd">
                {{ toCurrency(mobileEstimateDetail.storeSupportMoney) }}원
              </dd>
            </dl>
            <dl class="sb">
              <dt class="txt_1">구입가(할부원금)</dt>
              <dd class="txt_2">
                {{ toCurrency(mobileEstimateDetail.principal) }}원
              </dd>
            </dl>
          </div>
          <div class="con_txt">
            <dl class="mb04 sb">
              <dt class="txt_1">가입요금제</dt>
              <dd class="txt_2">{{ mobileEstimateDetail.joinPlanName }}</dd>
            </dl>
            <dl class="mb04 sb">
              <dt class="txt_1">월 정액</dt>
              <dd class="txt_2">
                {{ toCurrency(mobileEstimateDetail.joinPlanPrice) }}원
              </dd>
            </dl>
            <dl class="mb04 sb" v-if="mobileEstimateDetail.payType == 'PLAN'">
              <dt class="txt_1">선택약정할인</dt>
              <dd class="txt_2 brd">
                -{{ toCurrency(mobileEstimateDetail.joinPlanDcMoney) }}원
              </dd>
            </dl>
            <dl class="sb" v-if="mobileEstimateDetail.payType == 'PLAN'">
              <dt class="txt_1">월 요금</dt>
              <dd class="txt_2">
                {{ toCurrency(mobileEstimateDetail.joinMonthlyRate) }}원
              </dd>
            </dl>
          </div>
          <div
            class="con_txt_sub"
            v-if="
              (mobileEstimateDetail.joinPlanInfo.telecomId == 'SKT' ||
                mobileEstimateDetail.joinPlanInfo.telecomId == 'KT' ||
                mobileEstimateDetail.joinPlanInfo.telecomId == 'LGUPLUS') &&
                mobileEstimateDetail.networkType != ''
            "
            v-html="getJoinPlanTxt(mobileEstimateDetail)"
          ></div>
          <div id="more_info" class="more_info">
            <div class="con_txt">
              <div class="con_txt_box">
                <dl class="mb08 sb">
                  <dt class="txt_1 cbb">월 납부금액</dt>
                  <dd class="txt_2 brd">
                    {{ toCurrency(mobileEstimateDetail.joinTotalPrice) }}원
                  </dd>
                </dl>
                <dl class="mb08 sb">
                  <dt class="txt_1">월 단말할부금(할부이자 포함)</dt>
                  <dd class="txt_2">
                    {{ toCurrency(mobileEstimateDetail.monthlyInstallment) }}원
                  </dd>
                </dl>
                <dl class="mb08 sb">
                  <dt class="txt_1">월 요금</dt>
                  <dd class="txt_2">
                    {{ toCurrency(mobileEstimateDetail.joinMonthlyRate) }}원
                  </dd>
                </dl>
                <div class="box_txt_1">
                  ※ <span>결합할인, 복지할인, 제휴카드할인</span> 등 별도 할인
                  미포함
                </div>
              </div>
            </div>
            <div class="con_txt btmb">
              <div class="con_txt_title mb04">
                부가서비스/휴대폰보험 의무사용
              </div>
              <dl class="mb04 sb" v-if="mobileEstimateDetail.supServiceName1">
                <dt class="txt_1">
                  {{ mobileEstimateDetail.supServiceName1 }}
                </dt>
                <dd class="txt_2">
                  <div class="txt_2_1 mb04">
                    월 {{ toCurrency(mobileEstimateDetail.supServicePrice1) }}원
                  </div>
                  <div class="txt_2_2">
                    ※ 가입 후 {{ mobileEstimateDetail.supServiceDuty1 }} 경과 시
                    해지 가능
                  </div>
                </dd>
              </dl>
              <dl class="mb04 sb" v-if="mobileEstimateDetail.supServiceName2">
                <dt class="txt_1">
                  {{ mobileEstimateDetail.supServiceName2 }}
                </dt>
                <dd class="txt_2">
                  <div class="txt_2_1 mb04">
                    월 {{ toCurrency(mobileEstimateDetail.supServicePrice2) }}원
                  </div>
                  <div class="txt_2_2">
                    ※ 가입 후 {{ mobileEstimateDetail.supServiceDuty2 }} 경과 시
                    해지 가능
                  </div>
                </dd>
              </dl>
              <dl class="mb04 sb" v-if="mobileEstimateDetail.supServiceName3">
                <dt class="txt_1">
                  {{ mobileEstimateDetail.supServiceName3 }}
                </dt>
                <dd class="txt_2">
                  <div class="txt_2_1 mb04">
                    월 {{ toCurrency(mobileEstimateDetail.supServicePrice3) }}원
                  </div>
                  <div class="txt_2_2">
                    ※ 가입 후 {{ mobileEstimateDetail.supServiceDuty3 }} 경과 시
                    해지 가능
                  </div>
                </dd>
              </dl>
              <dl class="mb04 sb" v-if="mobileEstimateDetail.supServiceName4">
                <dt class="txt_1">
                  {{ mobileEstimateDetail.supServiceName4 }}
                </dt>
                <dd class="txt_2">
                  <div class="txt_2_1 mb04">
                    월 {{ toCurrency(mobileEstimateDetail.supServicePrice4) }}원
                  </div>
                  <div class="txt_2_2">
                    ※ 가입 후 {{ mobileEstimateDetail.supServiceDuty4 }} 경과 시
                    해지 가능
                  </div>
                </dd>
              </dl>
              <dl class="mb04 sb" v-if="mobileEstimateDetail.supServiceName5">
                <dt class="txt_1">
                  {{ mobileEstimateDetail.supServiceName5 }}
                </dt>
                <dd class="txt_2">
                  <div class="txt_2_1 mb04">
                    월 {{ toCurrency(mobileEstimateDetail.supServicePrice5) }}원
                  </div>
                  <div class="txt_2_2">
                    ※ 가입 후 {{ mobileEstimateDetail.supServiceDuty5 }} 경과 시
                    해지 가능
                  </div>
                </dd>
              </dl>
              <dl class="mb04 sb" v-if="mobileEstimateDetail.insuranceName">
                <dt class="txt_1">
                  {{ mobileEstimateDetail.insuranceName }}
                </dt>
                <dd class="txt_2">
                  <div class="txt_2_1 mb04">
                    월 {{ toCurrency(mobileEstimateDetail.insurancePrice) }}원
                  </div>
                  <div class="txt_2_2">
                    ※ 가입 후 {{ mobileEstimateDetail.insuranceName }} 경과 시
                    해지 가능
                  </div>
                </dd>
              </dl>
            </div>
            <div class="con_txt_sub mt16">
              ※ 유심비는 별도 청구될 수 있습니다.
            </div>
            <div
              class="con_txt"
              v-if="mobileEstimateDetail.giftItem || mobileEstimateDetail.info"
            >
              <div class="con_txt_box">
                <div class="box_txt_2">
                  <div
                    class="txt_1"
                    :class="{ pbb: mobileEstimateDetail.info }"
                    v-if="mobileEstimateDetail.giftItem"
                  >
                    사은품: {{ mobileEstimateDetail.giftItem }}
                  </div>
                  <div
                    class="txt_2"
                    :class="{ pt: mobileEstimateDetail.giftItem }"
                    v-if="mobileEstimateDetail.info"
                    v-html="$options.filters.nl2br(mobileEstimateDetail.info)"
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div class="more_btm" @click="showDetailView()">
            <button class="btn_detail" id="btn_detail">
              <span></span>
            </button>
          </div>
        </div>
      </div>

      <div class="mobile_apply_detail">
        <div class="ad_title">
          <div class="txt_1">고객 가입 정보</div>
        </div>
        <div class="ad_con_wrap" v-if="isInfoView">
          <div class="ad_con bb pb bt">
            <div class="con_title">개인정보</div>
            <div class="con_txt">
              <dl class="mb04">
                <dt class="txt_1">이름</dt>
                <dd class="txt_2">{{ mobileApplyDetail.name }}</dd>
              </dl>
              <dl class="mb04">
                <dt class="txt_1">생년월일</dt>
                <dd class="txt_2">{{ mobileApplyDetail.residentNumber }}</dd>
              </dl>
              <dl class="mb04" v-if="mobileApplyDetail.currentTelecomId != ''">
                <dt class="txt_1">현재통신사</dt>
                <dd class="txt_2">
                  {{ getTelecomName(mobileApplyDetail.currentTelecomId) }}
                </dd>
              </dl>
              <dl class="mb04">
                <dt class="txt_1">휴대폰번호</dt>
                <dd class="txt_2">{{ mobileApplyDetail.mobileNumber }}</dd>
              </dl>
              <dl class="mb04">
                <dt class="txt_1">주소</dt>
                <dd class="txt_2">
                  {{ mobileApplyDetail.address }}
                  {{ mobileApplyDetail.addressDetail }}
                </dd>
              </dl>
              <dl>
                <dt class="txt_1">이메일</dt>
                <dd class="txt_2">{{ mobileApplyDetail.email }}</dd>
              </dl>
            </div>
          </div>

          <div class="ad_con bb pb bt">
            <div class="con_title">요금납부정보(자동이체)</div>
            <div
              class="con_txt"
              v-if="mobileApplyDetail.paymentMethod == 'CARD'"
            >
              <dl class="mb04">
                <dt class="txt_1">카드사</dt>
                <dd class="txt_2">{{ mobileApplyDetail.cardName }}</dd>
              </dl>
              <dl class="mb04">
                <dt class="txt_1">카드주</dt>
                <dd class="txt_2">{{ mobileApplyDetail.cardOwner }}</dd>
              </dl>
              <dl class="mb04">
                <dt class="txt_1">카드번호</dt>
                <dd class="txt_2">{{ mobileApplyDetail.cardNumber }}</dd>
              </dl>
              <dl class="">
                <dt class="txt_1">유효기간</dt>
                <dd class="txt_2">
                  {{ mobileApplyDetail.cardMonth }}월 /
                  {{ mobileApplyDetail.cardYear }}년
                </dd>
              </dl>
            </div>
            <div
              class="con_txt"
              v-else-if="mobileApplyDetail.paymentMethod == 'BANK'"
            >
              <dl class="mb04">
                <dt class="txt_1">예금주명</dt>
                <dd class="txt_2">{{ mobileApplyDetail.bankOwner }}</dd>
              </dl>
              <dl class="mb04">
                <dt class="txt_1">은행명</dt>
                <dd class="txt_2">{{ mobileApplyDetail.bankName }}</dd>
              </dl>
              <dl class="">
                <dt class="txt_1">계좌번호</dt>
                <dd class="txt_2">{{ mobileApplyDetail.bankNumber }}</dd>
              </dl>
            </div>
          </div>

          <div class="ad_con pb bt">
            <div class="con_title">본인인증방법</div>
            <div class="con_txt">
              <dl class="">
                <dt class="txt_1">본인인증방법</dt>
                <dd class="txt_2">
                  {{ getAuthMethod(mobileApplyDetail.authMethod) }}
                </dd>
              </dl>
            </div>
            <p class="btm_txt">
              ※기입된 인적사항은 보름 후 비공개됩니다.
            </p>
          </div>
        </div>
        <div class="ad_con_wrap" v-else>
          <div class="txt_blind">
            <div>고객님의 인적사항은 비공개 전환되었습니다.</div>
            <br />
            <div>내용의 확인을 원하시면</div>
            <div>고객센터로 문의를 바랍니다.</div>
          </div>
        </div>
      </div>

      <div
        class="mobile_apply_notice"
        v-if="mobileApplyDetail.applyType == 'PROMISE'"
      >
        <div class="an_title">
          필수 안내 사항
        </div>
        <div class="an_con">
          <div class="an_box">
            ★ 매장에서 보낸 견적은 통신사 정책에 따라 수 일 혹은 수 시간 단위로
            변경될 수 있기에 가급적 빠른 시간 내에 매장에 방문하시길
            추천드립니다.
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import * as util from '@common/lib/common/utils.js';
import { default as format } from 'date-fns/format';
import parseISO from 'date-fns/parseISO';

import {
  mapActions as shopMapActions,
  mapGetters as shopMapGetters,
} from '@common/store/modules/shop';
import * as shopTypes from '@common/store/modules/shop/types';

import {
  mapActions as mobileMapActions,
  mapGetters as mobileMapGetters,
} from '@common/store/modules/mobile';
import * as mobileTypes from '@common/store/modules/mobile/types';
import { faTshirt } from '@fortawesome/free-solid-svg-icons';

export default {
  components: {
    // Datepicker,
  },
  data() {
    return {
      isCompleted: false,
      isInfoView: true,
      estimateId: 0,
      message: '',
      openType: '', // VISIT, ONLINE
      currentTelecom: [
        { telecomId: 'SKT', telecomName: 'SKT' },
        { telecomId: 'KT', telecomName: 'KT' },
        { telecomId: 'LGUPLUS', telecomName: 'LGU+' },
        { telecomId: 'MVNO', telecomName: '알뜰폰' },
      ],
      currentTelecomFilter: [],
      mobileApplyDetail: '',
      planDuty: [
        { name: '0개월 (없음)', value: '0' },
        { name: '1개월', value: '1' },
        { name: '2개월', value: '2' },
        { name: '3개월', value: '3' },
        { name: '4개월', value: '4' },
        { name: '5개월', value: '5' },
        { name: '6개월', value: '6' },
        { name: '0개월 (없음)', value: '0M' },
        { name: '1개월', value: '1M' },
        { name: '2개월', value: '2M' },
        { name: '3개월', value: '3M' },
        { name: '4개월', value: '4M' },
        { name: '5개월', value: '5M' },
        { name: '6개월', value: '6M' },
        { name: 'D+93일', value: 'D+93' },
        { name: 'D+95일', value: 'D+95' },
        { name: 'D+123일', value: 'D+123' },
        { name: 'D+125일', value: 'D+125' },
        { name: 'M+3개월', value: 'M+3' },
        { name: 'M+4개월', value: 'M+4' },
        { name: 'M+6개월', value: 'M+6' },
      ],
      auth: [
        { name: '신용카드인증', id: 'CARD' },
        { name: 'PASS인증서', id: 'PASS' },
        { name: 'TOSS인증서', id: 'TOSS' },
        { name: '네이버인증서', id: 'NAVER' },
        { name: '범용공인인증서', id: 'CERT' },
        { name: '신분증원본스캔', id: 'SCAN' },
        { name: '모바일 신분증', id: 'MOBILE' },
      ],
    };
  },
  filters: {
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    nl2br(val) {
      return String(val)
        .split('\n')
        .join('<br />');
    },
  },
  async created() {
    console.log('this.$route.params');
    console.log(this.$route.params);

    this.applyId = this.$route.params.applyId;

    if (!this.applyId) {
      this.$router.go(-1);
      return;
    }

    await this.getMobileApplyDetail();

    console.log(this.mobileApplyDetail.cancel);

    if (this.mobileApplyDetail.cancel) {
      this.$router.go(-1);
      return;
    }

    this.estimateId = this.mobileApplyDetail.estimateId;

    await this.getEstimateDetail();
    await this.getRequestView(this.mobileEstimateDetail.requestId);
    await this.getStore(this.mobileApplyDetail.estimateDto.storeId);

    const now = format(new Date(), 'yyyy-MM-dd HH:mm:ss');
    const createdAt = new Date(this.mobileApplyDetail.createdAt);

    const sDays = format(
      new Date(createdAt.setDate(createdAt.getDate() + 15)),
      'yyyy-MM-dd HH:mm:ss',
    );

    if (now > sDays) {
      this.isInfoView = false;
    } else {
      this.isInfoView = true;
    }

    this.isCompleted = true;
  },
  updated() {},
  computed: {
    ...shopMapGetters({
      shop: shopTypes.SHOP,
    }),
    ...mobileMapGetters({
      mobileRequestView: mobileTypes.MOBILE_REQUEST_VIEW,
      mobileEstimateDetail: mobileTypes.MOBILE_ESTIMATE_DETAIL,
    }),
  },
  methods: {
    ...shopMapActions([shopTypes.FETCH_SHOP]),
    ...mobileMapActions([
      mobileTypes.SELECT_MOBILE_REQUEST_VIEW,
      mobileTypes.SELECT_MOBILE_ESTIMATE_DETAIL,
      mobileTypes.CREATE_MOBILE_APPLY_ONLINE,
      mobileTypes.SELECT_MOBILE_APPLY_DETAIL,
    ]),
    isCustomer() {
      return process.env.VUE_APP_APP_NAME === 'customer';
    },
    getCreateAt(createAt) {
      return format(parseISO(createAt), 'yyyy-MM-dd');
    },
    async getMobileApplyDetail() {
      const params = {
        id: parseInt(this.applyId, 10),
      };
      this.mobileApplyDetail = await this[
        mobileTypes.SELECT_MOBILE_APPLY_DETAIL
      ](params);

      console.log(params);
      console.log('mobileApplyDetail');
      console.log(this.mobileApplyDetail);
    },
    toCurrency(val) {
      return util.toCurrency(val);
    },
    getJoinPlanTxt(estimate) {
      if (estimate.payType == 'SUPPORT') {
        let planPrice = '';
        if (estimate.joinPlanInfo.telecomId == 'SKT') {
          if (estimate.networkType == '5G') {
            planPrice = '42,000';
          } else {
            // LTE
            planPrice = '20,000';
          }
        } else if (estimate.joinPlanInfo.telecomId == 'KT') {
          if (estimate.networkType == '5G') {
            planPrice = '47,000';
          } else {
            // LTE
            planPrice = '20,000';
          }
        } else if (estimate.joinPlanInfo.telecomId == 'LGUPLUS') {
          if (estimate.networkType == '5G') {
            planPrice = '45,000';
          } else {
            // LTE
            planPrice = '26,400';
          }
        }
        return (
          '※ 가입 후 ' +
          this.getJoinPlanDuty(estimate.joinPlanDuty) +
          ' 경과 시 <span>' +
          planPrice +
          '원 이상</span> 요금제로 변경 가능'
        );
      } else if (estimate.payType == 'PLAN') {
        return (
          '※ 가입 후 ' +
          this.getJoinPlanDuty(estimate.joinPlanDuty) +
          ' 경과 시 요금제 변경 가능'
        );
      } else {
        return '';
      }
    },
    getJoinPlanDuty(joinPlanDuty) {
      console.log(joinPlanDuty);
      const foundInfo = this.planDuty.find(info => info.value === joinPlanDuty);
      if (foundInfo == undefined) {
        return joinPlanDuty + '개월';
      }

      return foundInfo.name;
    },
    getAddress(address) {
      if (address) {
        const addr = address.split(' ');
        return addr[0] + ' ' + addr[1] + ' ' + addr[2];
      } else {
        return address;
      }
    },
    async getRequestView(id) {
      let params = {
        callPart: 'CUSTOMER',
        id: parseInt(id, 10),
      };
      await this[mobileTypes.SELECT_MOBILE_REQUEST_VIEW](params);

      console.log(params);

      console.log('mobileRequestView');
      console.log(this.mobileRequestView);
    },
    async getStore(id) {
      await this[shopTypes.FETCH_SHOP]({
        id: id,
      });
      console.log(id);
      console.log('shop');
      console.log(this.shop);
    },
    async getEstimateDetail() {
      const params = {
        callPart: 'CUSTOMER',
        // requestId: parseInt(this.$route.params.requestId, 10),
        id: parseInt(this.estimateId, 10),
      };
      await this[mobileTypes.SELECT_MOBILE_ESTIMATE_DETAIL](params);

      console.log(params);
      console.log('mobileEstimateDetail');
      console.log(this.mobileEstimateDetail);
    },

    getAuthMethod(auth) {
      const foundInfo = this.auth.filter(info => info.id === auth);

      return foundInfo[0].name;
    },
    getTelecomName(telecomId) {
      const foundInfo = this.currentTelecom.filter(
        info => info.telecomId === telecomId,
      );

      return foundInfo[0].telecomName;
    },
    showDetailView() {
      var someElement = document.getElementById(`btn_detail`);
      someElement.classList.toggle('on');

      var infoSomeElement = document.getElementById(`more_info`);
      infoSomeElement.classList.toggle('on');
    },
  },
};
</script>
